import { CurrencyUtils } from "../common/CurrencyUtils";
import { Sell } from "../domain/models/Sell";
import { SellRepository } from "../domain/repositories/SellRepository";
import { axiosApp } from './remote/AxiosFactory';
import { handleRemoteResponse } from './remote/hanldeRemoteResponse';
import { RequestParam } from "../domain/models/RequestParam";
import { urlBuild } from './remote/urlBuild';
import { SkuConstraints, SkuDetail, SkuDetailSection } from "../domain/models/SkuDetail";
import { handleAxiosResult } from './remote/handleAxiosResult';
import { BalanceActions } from "../presentation/redux/actions/BalanceActions";

export class SellDataRepository implements SellRepository {

    async sell(requestParams: RequestParam[]): Promise<SkuDetail> {
        console.log('🟣 [SellDataRepository.sell] Params recibidos:', requestParams.map(p => ({ name: p.name, value: p.value, isHidden: p.isHidden })));
        const refParam = requestParams.find(param => param.name === 'ref');
        const attrParam = requestParams.find(param => param.name === 'attr');
        console.log('🟣 [SellDataRepository.sell] ref:', refParam?.value, '| attr:', attrParam?.value);
        if (refParam && refParam.value && refParam.value.trim() !== '' && !attrParam) {
            console.log('🟣 [SellDataRepository.sell] → Enrutando a processActivationQR');
            return this.processActivationQR(requestParams);
        }

        const processedParams = requestParams
            .filter(param => param.name !== 'clientDebt')
            .map(param => new RequestParam(
                param.name,
                param.value,
                param.description,
                param.isHidden,
                param.subprod
            ));

        if (!processedParams.some(p => p.name === 'ref')) {
            processedParams.push(new RequestParam('ref', '', 'Referencia', true));
        }

        const response = await handleAxiosResult(axiosApp().get(urlBuild('/topup/send/request?', processedParams)));
        
        return handleRemoteResponse(response, (r: any) => {
            return new SkuDetail({
                response: r.map((section: any) => {
                    return new SkuDetailSection({
                        ...section,
                        constraints: new SkuConstraints({
                            ...section.constraints
                        })
                    });
                })
            })
        });
    }

    private async processActivationQR(requestParams: RequestParam[]): Promise<SkuDetail> {
        const tokenParam = requestParams.find(param => param.name === 'token');
        const refParam = requestParams.find(param => param.name === 'ref');
        
        if (!tokenParam || !refParam) {
            throw new Error('Token y referencia son requeridos para activaciones QR');
        }

        const response = await handleAxiosResult(
            axiosApp().get(`/activaciones/process?token=${tokenParam.value}&ref=${refParam.value}`)
        );
        
        return handleRemoteResponse(response, (r: any) => {
            return new SkuDetail({
                response: r.map((section: any) => {
                    return new SkuDetailSection({
                        ...section,
                        constraints: new SkuConstraints({
                            ...section.constraints
                        })
                    });
                })
            })
        });
    }

    async processSale(requestParams: RequestParam[], ref: string, dispatch?: any): Promise<any> {
        const saleParams = [
            ...requestParams,
            new RequestParam('ref', ref, 'Referencia de la transacción', true)
        ];

        const response = await handleAxiosResult(
            axiosApp().get(urlBuild('/topup/send/request?', saleParams))
        );

        const result = handleRemoteResponse(response, (r: any) => r);

        // Después de procesar la respuesta, actualizar balance e historial
        if (response.data.code === 'OK') {
            const tokenParam = requestParams.find(param => param.name === 'token');
            
            if (tokenParam && dispatch && typeof dispatch === 'function') {
                try {
                    dispatch(BalanceActions.updateBalance(tokenParam.value));
                } catch (error) {
                    console.error('Error al actualizar balance después de venta:', error);
                }
            }
        }
                
        return result;
    }

    async getHistoric(token: string): Promise<Sell[]> {
        const result = await handleAxiosResult(
            axiosApp().get(`/pos/ops/tail?token=${token}`));

        return handleRemoteResponse(result, (json: any) => {
            return json.map((r: any) => {
                return new Sell({
                    ...r,
                    amount: CurrencyUtils.removeCurrency(r.amount),
                    comision: CurrencyUtils.removeCurrency(r.comision),
                })
            })
        })
    }

    async getSellsPerDay(date: string, all: boolean): Promise<Sell[]> {
        const result = await handleAxiosResult(axiosApp().get(`/pos/ops/by/date?&date=${date}&pag=0&all=${all}`))
        return handleRemoteResponse(result, (json: any) => {
            return json.map((r: any) => {
                return new Sell({
                    ...r,
                    amount: CurrencyUtils.removeCurrency(r.amount),
                    comision: CurrencyUtils.removeCurrency(r.comision),
                })
            })
        })
    }
}